import React from 'react';
import {createForm} from 'core/form/createForm';
import {lovValue, lovLabel, FieldText, FormProps, ClosedContentProps} from 'core/form/formUtils';
import ProductService from 'product/productService';
import StyledSelect from 'core/components/fields/styledSelect';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {Validate} from 'core/form/validate';
import PriceComponentAssignedForm from 'product/component/priceComponentAssignedForm';
import {MdIconButton} from "core/components/buttons/icons";
import Add from "material-ui/svg-icons/content/add";
import {formatInterval} from "core/common/utils/dateUtils";
import {ProductVehicle, Vehicle, PriceComponent} from "product/productDomain";
import {action} from "mobx";
import Form from "core/form/form";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {optionsSearch} from "core/common/service/commonDataService";

@observer
class ProductVehicleForm extends React.Component<FormProps<ProductVehicle, Vehicle>, undefined> {

  @action addPrice = () => {
    let {dataObject, rootObject, entities} = this.props;
    ProductService.initPriceComponent(lovValue(rootObject.party))
      .then(action("addPrice-handler", (priceComponent: PriceComponent) => {
        dataObject.prices.push(priceComponent.initAfterRead(true));
        dataObject.$dirty = true;
        console.debug("addPrice %O", dataObject);
      }));
  };


  @action deletePrice = (index) => {
    let {dataObject, rootObject, entities} = this.props;

    console.log('delete price ' + index);
    dataObject.prices.splice(index, 1);
    dataObject.$dirty = true;
  };




  render() {

    let {dataObject, rootObject, entities} = this.props;
    let fields =  dataObject.getFormFields(definition.formName);
    let {product, validFrom, validTo} = fields;


    return (
      <div>
        <div className="row">
          <div className="fx col-xs-6">
            <StyledSelect {...product.props} disabled={!dataObject.$new} async loadOptions={optionsSearch.bind(this, 'Product', {})} clearable asterixForAll />
            <Validate field={product} value={product.props.value}/>
          </div>
          <div className="col-xs-6">
            <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value}
                                onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
          </div>
        </div>
        <div className="row">
          <h5 style={{display: 'flex', alignItems: 'center', margin:'0 0 0 5px', fontSize:18}}>
            <span>Prices</span>
            <MdIconButton onClick={this.addPrice}>
              <Add />
            </MdIconButton>
          </h5>
        </div>
          {
            (dataObject.prices) ?
            dataObject.prices.map( (priceObject, index, array) => <PriceComponentAssignedForm dataObject={priceObject} rootObject={dataObject} key={index}
                                                                             entities={mdEntityService.entityMap} entity={mdEntityService.getEntity('PriceComponent')}
                                                                              index={index} onDelete={this.deletePrice}/> )
              : null
          }
      </div>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields}: ClosedContentProps<ProductVehicle>) => (
  <div>
    <div className="form-text-row" style={{fontSize: 16, lineHeight: '16px', minHeight: 20}}>
      {lovLabel(dataObject.product)}
    </div>
    <div className="form-text-row">
      <FieldText label={fields.validFrom.textLabel} value={formatInterval(dataObject.validFrom, dataObject.validTo)} />
    </div>
  </div>
);

const definition = {
  formName: 'ProductVehicleForm',
  fields: [{
    name: 'product',
    validators: ['IsRequired']
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }],
  nestedForms: [{path: 'prices', formName: 'PriceComponentAssignedForm'}]
};

export default createForm(definition, ClosedContent)(ProductVehicleForm);






// WEBPACK FOOTER //
// ./src/product/component/productVehicleForm.tsx